var _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.45957,-9.45957) scale(1.11,1.11)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,171.99219v-171.99219h171.99219v171.99219z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.35,156.75v-142.5h75.81l32.49,32.49v110.01z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.02,17.1l30.78,30.78v106.02h-102.6v-136.8h71.82M108.3,11.4h-79.8v148.2h114v-114l-34.2,-34.2z",
    fill: "#c74343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.45,48.45v-34.2h1.71l32.49,32.49v1.71z",
    fill: "#ffd9d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3,19.38l26.22,26.22h-26.22v-26.22M108.3,11.4h-5.7v39.9h39.9v-5.7l-34.2,-34.2zM57,131.1c-2.85,0 -5.7,-2.28 -5.7,-5.13c0,-6.27 7.98,-10.83 17.67,-14.25c1.71,-2.85 3.42,-6.27 5.13,-10.26c2.28,-5.13 3.99,-9.69 5.13,-13.68c-2.28,-6.27 -3.42,-11.97 -3.42,-15.96c0,-2.28 0.57,-4.56 1.14,-5.7c2.28,-3.99 7.98,-3.99 10.26,0c0.57,1.14 1.14,3.42 1.14,5.7c0,3.99 -1.14,9.69 -2.85,15.96c2.85,6.84 6.84,13.68 11.4,18.81c7.98,-0.57 13.68,-0.57 17.1,1.14c5.13,1.71 5.7,4.56 5.7,6.27c0,1.71 -0.57,6.84 -8.55,6.84c-6.27,0 -11.97,-3.42 -16.53,-7.98c-4.56,0.57 -9.69,1.14 -15.39,2.85c-2.28,0.57 -4.56,1.14 -6.27,1.71c-5.13,7.41 -10.83,13.68 -15.96,13.68zM63.27,120.27c-3.99,2.28 -5.7,3.99 -6.27,5.13c1.71,-0.57 3.99,-2.28 6.27,-5.13zM102.6,111.15c2.85,1.71 5.7,2.85 8.55,2.85c2.85,0 2.85,-0.57 2.85,-1.14h2.85h-2.85c-0.57,-1.14 -5.13,-1.71 -11.4,-1.71zM82.65,95.19c-1.71,4.56 -3.99,9.69 -6.27,14.25c4.56,-1.14 9.12,-2.28 13.11,-2.85c-2.28,-3.42 -4.56,-7.41 -6.84,-11.4zM82.08,68.4c-0.57,0.57 -1.14,2.85 0,8.55c1.14,-5.13 1.14,-7.98 0,-8.55z",
    fill: "#c74343"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.b84312fa.svg";
export { ForwardRef as ReactComponent };